import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useBranding } from '../../contexts/BrandingContext';

export const loadPlatformBranding = async () => {
  try {
    const cached = JSON.parse(localStorage.getItem('telcofair:platform-branding') || '{}');
    return { name: cached.name || 'TELCOFAIR', logo: cached.logo || '' };
  } catch (_) {
    return { name: 'TELCOFAIR', logo: '' };
  }
};

const PlatformLogo = ({
  size = 40,
  width,
  height,
  radius = 12,
  alt = 'TELCOFAIR',
  fit = 'contain',
  padding = '2%',
  sx = {},
  imgSx = {},
}) => {
  const brand = useBranding();
  const [failed, setFailed] = useState(false);
  const resolvedWidth = width ?? size;
  const resolvedHeight = height ?? size;
  const fontBase = Math.min(Number(resolvedWidth) || 40, Number(resolvedHeight) || 40);

  return (
    <Box sx={{
      width: resolvedWidth,
      height: resolvedHeight,
      borderRadius: `${radius}px`,
      flex: '0 0 auto',
      display: 'grid',
      placeItems: 'center',
      overflow: 'hidden',
      bgcolor: '#fff',
      border: '1px solid rgba(31,62,82,.10)',
      boxShadow: '0 7px 18px rgba(25,57,78,.09)',
      ...sx,
    }}>
      {brand.logo && !failed ? (
        <Box
          component="img"
          src={brand.logo}
          alt={alt || brand.name}
          onError={() => setFailed(true)}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: fit,
            objectPosition: 'center',
            p: padding,
            bgcolor: '#fff',
            display: 'block',
            ...imgSx,
          }}
        />
      ) : (
        <Box sx={{
          width: '100%',
          height: '100%',
          display: 'grid',
          placeItems: 'center',
          color: 'var(--brand-action-text,#fff)',
          background: 'linear-gradient(145deg,var(--primary,#2E6F8E),var(--secondary,#42B89B))',
          fontWeight: 900,
          fontSize: Math.max(10, fontBase * .3),
          letterSpacing: '.04em',
        }}>TF</Box>
      )}
    </Box>
  );
};

export default PlatformLogo;
